import React, { Component } from 'react';
import { Card, CardBody } from 'reactstrap';



class OpenTickets extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loaderMap: false,
        };
    }

    render() {
        return (
            <>
                <Card>
                    <CardBody>
                        Opend
                    </CardBody>
                </Card>
            </>
        );
    }
}

export default OpenTickets;